import React from 'react'
import { Box, Button } from '@mui/material'

interface OnboardFooterButtonProps {
  onBack: () => void
  onNext: () => void
  nextBtnLabel: string
  isValid?: boolean
}

const OnboardFooterButton: React.FC<OnboardFooterButtonProps> = ({
  onBack,
  onNext,
  isValid = false,
  nextBtnLabel,
}) => {
  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
      <Button variant="outlined" onClick={onBack}>
        Back
      </Button>
      <Button variant="contained" onClick={onNext} disabled={!isValid}>
        {nextBtnLabel}
      </Button>
    </Box>
  )
}

export default OnboardFooterButton
